export default "/images/bc5b792b79ceaa818a4d7fe6f1bf6bb1.avif";